<template>
	<div id='ae' class='' v-loading='loading'>

		<tyc :tqobj='tqobj'></tyc>

		<el-dialog class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
			<div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

				<span>
					<MechanismSelector style='' :data="mechanismData1"></MechanismSelector>
					<!-- <el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="channelId" clearable :placeholder="$t('app_distributor')">
            <el-option
              v-for="item in channels"
              :key="item.mechanismid"
              :label="item.mechanismname"
              :value="item.mechanismid">
            </el-option>
          </el-select> -->
				</span>

				<span>

					<el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="status" clearable
						:placeholder="$t('app_status')">
						<el-option v-for="item in stModel" :key="item.vl" :label="item.lb" :value="item.vl">
						</el-option>
					</el-select>
				</span>


				<el-input :placeholder="$t('app_searchTerminal')" icon="search" :on-icon-click="srchDevice"
					@keyup.enter.native='srchDevice' style='width:40%;margin-bottom:10px;' v-model="srchValue">
				</el-input>
			</div>




			<el-table :data="tableData" border tooltip-effect="dark" style="width: 100%">
				<el-table-column align='center' prop="terminalNo" :label="$t('app_terNo')" width="150">
				</el-table-column>
				<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="130">
				</el-table-column>
				<el-table-column prop="terminal_status" align='center' :label="$t('app_status')" width="90">
					<template slot-scope="scope">
						<!-- <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 4 " type="danger" size="mini">{{$t('lin_btn.lock')}}</el-tag> -->
						<tagc :tagobj="{type: 'terSt', vl: scope.row.terminalStatus}"></tagc>
					</template>
				</el-table-column>
				<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width=''>
				</el-table-column>
				<el-table-column prop="operate" :label="$t('app_operate')" align='center' width=''>
					<template slot-scope='scope'>
						<!-- <el-button  @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
						<el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
							<el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload"
									style=""></i></el-button>
						</el-tooltip>

					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style=''>

				<el-pagination @current-change="pageSelect" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="row" class='gPg' layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
				<!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

			</div>

		</el-dialog>

		<el-dialog title="" v-model="showPic.value" size='small'>
			<img :src='showPic.data' style='width:300px;'>
		</el-dialog>

		<div v-show="isShowReason">
			<el-alert style='display:flex;display:-webkit-flex;margin: 0 0 5px 0;' :title="reason" type="error"
				show-icon>
			</el-alert>
		</div>

		<div class='gPageBorder'>
			<!-- <div style='height:54px;border;border:1px solid #EAEEFA;border-top-left-radius:7px;border-top-right-radius:7px;display:flex;display:-webkit-flex;align-items:center;'>
        <label style='margin-left:10px;font-size:16px;color:#5E6D82;'>{{$t('app_baseInfo')}}</label>
      </div> -->

			<el-form class='gForm' ref="form" :model='form' :rules='rules' label-position="right" label-width="12.5%"
				style=''>

				<el-form-item :label="$t('app_appName')" prop='appName'>
					<label class='aeMg contentColor'
						v-show="isShowCommon(1)">{{(config.data)? config.data.appName : ''}}</label>
					<el-input v-show="isShowCommon()" style='' class='aeMg' v-model='form.appName'></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('app_version')" prop='version'>
          <label class='' v-show="isShowCommon(1)">{{(config.data)? config.data.appVersion : ''}}</label>
          <label v-show="isShowCommon()" class='aeMg' style='' >{{form.version}}</label>
          <label v-show="!form.version && !config.data" class='aeMg' style='color:gray;' >{{$t('app_autoUpload')}}</label>
        </el-form-item>
        <el-form-item :label="$t('app_verTag')" prop='verTag'>
          <label class='aeMg contentColor' v-show="isShowCommon(1)">{{(config.data)? config.data.versioncode : ''}}</label>
          <label v-show="isShowCommon()" class='aeMg' style='' >{{form.verTag}}</label>
          <label v-show="!form.verTag && !config.data" class='aeMg' style='color:gray;' >{{$t('app_autoUpload')}}</label>
        </el-form-item>
        <el-form-item :label="$t('app_package')" prop='packageName'>
          <label class='aeMg contentColor' v-show="isShowCommon(1)">{{(config.data)? config.data.packagename : ''}}</label>
          <label v-show="isShowCommon()" style='' class='aeMg' >{{form.packageName}}</label>
          <label v-show="!form.packageName && !config.data" class='aeMg' style='color:gray;' >{{$t('app_autoUpload')}}</label>
        </el-form-item> -->
				<el-form-item :label="$t('app_introl')" prop='appDesc'>
					<!-- <textarea  contenteditable="false" v-show="isShowCommon(1)" style='text-align:left;width:100%;' class='aeMg contentColor'>{{(config.data)? config.data.appDesc : ''}}</textarea> -->

					<div v-show="isShowCommon(1)">
						<div style='width:100%;border:0;height:100%;background:none;position:absolute;'></div>
						<el-input style='' type="textarea" :autosize="{ minRows: 2, maxRows: 1000}" placeholder="请输入内容"
							v-model='prdes'>
						</el-input>
					</div>

					<el-input v-show='isShowCommon()' type="textarea" :autosize="{ minRows: 2, maxRows: 9999}"
						v-model='form.appDesc' style='float:left;' class='aeMg'>
					</el-input>

					<!-- <textarea v-show='isShowCommon()' v-model='form.appDesc' type='file' style='width:40%;height:80px;border:1px solid #8492A6;font-size:13px;line-height:1.3' class='aeMg'></textarea> -->
				</el-form-item>

				<!-- <el-form-item :label="$t('app_insType')" >
            <label class='aeMg contentColor' v-show="isShowCommon(1)">{{config.data? setInstallType(config.data.appInstallType) : ''}}</label>
            <el-select v-show="isShowCommon()"  style='width:40%;' class='aeMg' clearableddd :placeholder="$t('app_insType')" v-model='form.installType'>
            <el-option
              v-for="item in installTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->

				<el-form-item :label="$t('app_distributor')" prop='distributorId'>
					<label class='aeMg contentColor'
						v-show="isShowCommon(1)">{{(config.data)? config.data.distributorName : ''}}</label>

					<MechanismSelector v-show="isShowCommon()" style='' :data="mechanismData"></MechanismSelector>

				</el-form-item>

				<el-form-item :label="$t('app_type')" prop='appTypeValue'>
					<label class='aeMg contentColor'
						v-show="isShowCommon(1)">{{(config.data)? config.data.appCategoryName : ''}}</label>

					<el-select v-show="isShowCommon() && form.distributorId" style='width:180px;' class='aeMg'
						v-model="form.appTypeValue" clearable :placeholder="$t('app_type')">
						<el-option v-for="item in appTypes" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!-- <el-cascader
            expand-trigger="hover"
            v-show="isShowCommon()"
            :options="appTypes"
            :show-all-levels="false"
            v-model="form.appTypeValue"
          ></el-cascader> -->
				</el-form-item>

				<el-form-item v-show='isShowUpdateDesc' :label="$t('app_udState')" prop='' style=''>
					<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 99999}" v-model='updateDescContent'
						style='width:100%;float:left;' class='aeMg'>
					</el-input>
				</el-form-item>


				<el-form-item :label="$t('app_selectApp')" v-show="isShowCommon()" prop='appUrl'>
					<label v-show="isShowCommon(1)">{{config ? makeAppPath() : ''}}</label>
					<el-upload v-show='isShowCommon() && form.distributorId' class="upload-demo aeMg" :data='uData' drag
						name='fileUpload' :file-list="fileList" :on-success="fileUploadSuccess"
						:before-upload="fileBeforeUpload" :action="fileUploadUrl">


						<span>
							<i v-if='ulinfo.index == 0' :class="ulinfo.icons[ulinfo.index]"></i>

							<div v-else style='margin-top:10px;'>
								<i :style=tipColor :class="ulinfo.icons[ulinfo.index]"></i>
								<p style="margin-top:-5px;color:#8c939d">{{$t('app_version')}}：{{form.version}}</p>
								<p style="margin-top:-10px;color:#8c939d">{{$t('app_verTag')}}：{{form.verTag}}</p>
								<p style="margin-top:-10px;color:#8c939d">{{$t('app_package')}}：{{form.packageName}}</p>
								<el-button type='primary'>{{$t('app_reupload')}}apk/hap</el-button>
							</div>

							<div v-show='ulinfo.index == 0' class="el-upload__text">{{ulinfo.tip}}</div>
						</span>

					</el-upload>

				</el-form-item>

				<el-form-item
					style='width:calc(100% + 20px);background:black;height:1px;background:#EAEEFA;margin-left:-10px;'>
				</el-form-item>
				<el-form-item :label="$t('app_icon')" prop='smImageUrlValue' v-loading='loadingSm'>
					<img class='aeMg' v-show='isShowCommon(1)' style='width:72px;height:72px' :src='sIcon'>
					<el-upload v-show='isShowCommon()' class="avatar-uploader aeMg" :action="imgUploadUrl"
						:show-file-list="false" name="file" :on-success="handleSmAvatarSuccess"
						:before-upload="beforeSmAvatarUpload">
						<img v-if="smImageUrl" :src="smImageUrl" class="sm-avatar">
						<i v-else class="el-icon-plus sm-avatar-uploader-icon"></i>
					</el-upload>
					&nbsp;&nbsp;<label class='contentColor' v-show='isShowCommon()'>{{$t('app_iconState')}}</label>
				</el-form-item>
				<el-form-item :label="$t('app_larIcon')" prop='bgImageUrlValue' v-loading='loadingBig'>
					<img class='aeMg' style='width:120px;height:120px;' v-show='isShowCommon(1)' @click='showBigPic'
						:src="bIcon">
					<el-upload v-show='isShowCommon()' class="avatar-uploader aeMg" :action="imgUploadUrl"
						:show-file-list="false" name="file" :on-success="handleBgAvatarSuccess"
						:before-upload="beforeBgAvatarUpload">
						<img v-if="bgImageUrl" :src="bgImageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					&nbsp;&nbsp;<label class='contentColor' v-show='isShowCommon()'>{{$t('app_larIconState')}}</label>
				</el-form-item>
				<el-form-item v-show='config.type!==3 || path' :label="$t('app_screenShot')" prop='caps'
					v-loading='loading1'>
					<div id='aeCpDiv' v-for='path,index in captures' style='float:left;margin-left:10px;'><img
							v-show='isShowCommon(1)' @click='showScreenShot(path, index)' :src="imgFullUrl(path)"
							class='cImg'></div>

					<div id='aeCap' style='background:none;text-align:left;padding: 0 0 0 15px;'>
						<el-upload style='margin-left:-10px;' v-show='isShowCommon()' class="capture"
							:action="imgUploadUrl" :show-file-list="false" name="file" :before-upload="tipBf"
							:on-success="handleAvatarSuccessCp0">
							<div style='display: -webkit-flex;justify-content: center;align-items: center;clear:both;'>
								<img v-if="cp0" :src="cp0" class="avatarF" style=''>
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</div>
						</el-upload><i v-show='isShowCommon()' @click='deleteCapture0()' class="el-icon-delete"
							style='margin-right:10px;'></i>


						<el-upload v-show='isShowCommon()' class="capture" :action="imgUploadUrl"
							:show-file-list="false" name="file" :before-upload="tipBf"
							:on-success="handleAvatarSuccessCp1">
							<img v-if="cp1" :src="cp1" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i v-show='isShowCommon()' @click='deleteCapture1()' class="el-icon-delete"
							style='margin-right:10px;'></i>
						<el-upload v-show='isShowCommon()' class="capture" :action="imgUploadUrl"
							:show-file-list="false" name="file" :before-upload="tipBf"
							:on-success="handleAvatarSuccessCp2">
							<img v-if="cp2" :src="cp2" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i v-show='isShowCommon()' @click='deleteCapture2()' class="el-icon-delete"
							style='margin-right:10px;'></i>
						<el-upload v-show='isShowCommon()' class="capture" :action="imgUploadUrl"
							:show-file-list="false" name="file" :before-upload="tipBf"
							:on-success="handleAvatarSuccessCp3">
							<img v-if="cp3" :src="cp3" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i v-show='isShowCommon()' @click='deleteCapture3()' class="el-icon-delete"
							style='margin-right:10px;'></i>
						<el-upload v-show='isShowCommon()' class="capture" :action="imgUploadUrl"
							:show-file-list="false" name="file" :before-upload="tipBf"
							:on-success="handleAvatarSuccessCp4">
							<img v-if="cp4" :src="cp4" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i v-show='isShowCommon()' @click='deleteCapture4()' class="el-icon-delete"
							style='margin-right:10px;'></i>
					</div>
				</el-form-item>
				<el-form-item v-show='config.type === 3' :label="$t('app_testInstall')"
					style='background:none;margin-top:30px;'>
					<el-button type='primary' class='aeMg' @click='pushInstall'>{{$t('app_pushInstall')}}</el-button>
				</el-form-item>
				<el-form-item v-show='config.type === 3' :label="$t('app_isPass')" style='background:none;'>
					<el-radio class="radio aeMg" v-model="radio" label="1">{{$t('app_pass')}}</el-radio>
					<el-radio class="radio aeMg" v-model="radio" label="2">{{$t('app_ban')}}</el-radio>
				</el-form-item>
				<el-form-item v-show="radio === '2'" :label="$t('app_banReason')" style='background:none;'>
					<textarea v-model='checkDesc' style='width:100%;height:60px;float:left;'></textarea>
				</el-form-item>
				<el-form-item style='background:none;' v-show='isShowCommon()'>
					<el-button class='aeMg' @click='cancel' type='' style=''>{{$t('app_cancel')}}</el-button>
					<el-button type='primary' style='' class='aeMg'
						@click="uploadApp('form')">{{$t('app_save')}}</el-button>
				</el-form-item>

				<el-form-item v-show='config.type === 3' label="" style='background:none;'>

					<el-button type='' @click='cancel' style=''>{{$t('app_cancel')}}</el-button>
					<el-button type='primary' @click='verifyPre' style=''>{{$t('app_submit')}}</el-button>

				</el-form-item>

			</el-form>

			<div v-show='config.type === 2 && config.isHistory' style='border-top:1px solid #8492A6;text-align:center;'>
				<p style='text-align:left;margin-top:20px'>{{$t('app_hisVer')}} </p>
				<el-button v-show="showUploadNew" @click='uploadNew' type='primary'
					style='float:right;margin-bottom:20px;'>{{$t('app_ulNew')}}</el-button>

				<el-table :data="tableData" border style="width: 100%;margin: 20px 0 20px 0;">
					<el-table-column header-align='center' align='center' prop="appName" :label="$t('app_appName')"
						width="">
					</el-table-column>
					<el-table-column header-align='center' align='center' prop="appVersion" width=''
						:label="$t('app_version')">
					</el-table-column>
					<el-table-column header-align='center' align='center' prop="appCategoryName" width=''
						:label="$t('app_type')">
					</el-table-column>

					<el-table-column header-align='center' align='center' :formatter="dateFormat" prop="createTime"
						width='170' :label="$t('app_createTime')">
					</el-table-column>
					<el-table-column header-align='center' align='center' prop="" width='90' :label="$t('app_operate')">
						<template slot-scope='scope'>


							<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
								<el-button type='text' @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o"
										style="color:#FF4949"></i></el-button>
							</el-tooltip>

							<!-- <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2'" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
								<el-button type='text'
									v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2'"
									@click='submitApp(scope.row)'><i class="fa fa-external-link-square"
										style=""></i></el-button>
							</el-tooltip>


							<!-- <el-button type=text @click='deleteAppHis(scope.row)'>{{$t('app_del')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
								<el-button type='text' @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o"
										style="color:#FF4949"></i></el-button>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table>
				<p>
					<!-- <el-button @click='close' type='primary'>{{$t('app_close')}}</el-button> -->

				</p>
			</div>

			<div v-show='config.type === 3'>

			</div>

		</div>
	</div>
</template>

<style>
	.contentColor {
		color: #495769
	}

	.avatarF {
		height: auto;
		width: 128px;
		display: block;
	}

	#ae {
		width: 100%;
		background: none;
	}

	.fs-icon {
		font-size: 18px;
	}


	#aeScreenCut img {
		heigth: 100%;
		width: auto;
	}

	/* upload */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	/* upload */
	.sm-avatar-uploader-icon {
		font-size: 36px;
		color: #8c939d;
		width: 72px;
		height: 72px;
		line-height: 72px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}

	#aeCpDiv {
		height: 180px;
		width: 120px;
		display: inline-block;
		background: none;
		margin-right: 10px;
	}

	.cImg {
		width: 100%;
	}
</style>

<script>
	import mm from 'moment'
	import tyc from '@/components/global/tyc'
	import tagc from '@/components/global/tagc'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		components: {
			tyc,
			tagc,
			MechanismSelector
		},
		data() {
			var dstCheck = (rule, value, callback) => {
				if (!value) {
					callback(new Error(this.$t('app_select')));
				} else {
					callback()
				}
			}
			var tagCheck = (rule, value, callback) => {
				if (!value) {
					callback(new Error(this.$t('noVerTag')));
				} else {
					callback()
				}
			}
			var that = this
			return {
				mechanismData: {
					callback(value) {
						// that.selectChange(value)
						if (!value) that.form.distributorId = ''
						that.getTypeList(value)
						that.form.appTypeValue = ''
						that.form.appUrl = ''
						that.form.distributorId = value == 1 ? '' : value
					}
				},
				mechanismData1: {
					callback(value) {
						that.channelId = value
						that.getDevices()
					}
				},
				tqobj: '',
				ulinfo: {
					tip: this.$t('app_ulAppState_2'),
					index: 0,
					icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
				},
				mechanismId: window.localStorage['mechanismId'],
				status: '',
				tipColor: {
					color: '#13CE66'
				},
				stModel: '',
				channels: [],
				channelId: '',
				rules: {
					appName: [{
						required: true,
						message: this.$t('app_inputName'),
						trigger: 'blur'
					}],
					version: [{
						required: true,
						message: this.$t('app_inputVer'),
						trigger: 'blur'
					}],
					verTag: [{
						required: true,
						message: this.$t('app_inputVerTag'),
						trigger: 'blur',
						validator: tagCheck
					}],
					packageName: [{
						required: true,
						message: this.$t('app_inputPkg'),
						trigger: 'blur'
					}],
					appDesc: [{
						required: true,
						message: this.$t('app_inputIntrol'),
						trigger: 'blur'
					}],
					distributorId: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur'
					}],
					appTypeValue: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur',
						validator: dstCheck
					}],
					appUrl: [{
						required: true,
						message: this.$t('app_ulApp'),
						trigger: 'blur'
					}]
					/*,
					          smImageUrlValue: [
					            { required: true, message: this.$t('app_ulIcon'), trigger: 'blur' }
					          ],
					          bgImageUrlValue: [
					            { required: true, message: this.$t('app_ulLarIcon'), trigger: 'blur' }
					          ],
					          caps: [
					            { required: true, message: this.$t('app_ulScreenShot'), trigger: 'blur' }
					          ]*/
				},
				form: {
					appName: '',
					version: '',
					verTag: '',
					packageName: '',
					appDesc: '',
					installType: 0,
					appTypeValue: '',
					appUrl: '',
					smImageUrlValue: '',
					bgImageUrlValue: '', // 上传值
					caps: '',
					md5: '',
					distributorId: ''
				},
				showPic: {
					value: 0,
					data: ''
				},
				srchValue: '',
				installTypes: [{
					label: this.$t('app_autoInstall'),
					value: 0
				}],
				fileSize: 0, // 上传文件大小
				tableData: [],
				checkDesc: '',
				radio: '1',
				smImageUrl: '',
				bgImageUrl: '',
				dialogVisible: false,
				appTypes: [],
				loading: 0,
				loading1: 0,
				loadingBig: 0,
				loadingSm: 0,
				config: {},
				cp0: '',
				cp1: '',
				cp2: '',
				cp3: '',
				cp4: '',
				captures: [],
				fileList: [],
				isUpload: 0,
				index: 1,
				total: 0
			}
		},
		computed: {
			bIcon() {
				if (this.config.data) {
					return this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : require(
						'../../assets/df.png')
				} else {
					return ''
				}
			},
			sIcon() {
				if (this.config.data) {
					return this.config.data.appSmallIcon ? this.imgFullUrl(this.config.data.appSmallIcon) : require(
						'../../assets/df.png')
				} else {
					return ''
				}
			},
			showUploadNew() {
				if (this.config.data) {
					if (this.config.data.isUpload === '0') {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			isShowUpdateDesc() {
				if (this.config.data) {
					if (this.config.data.updatedesc) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			updateDescContent() {
				var vl = this.config.data ? this.config.data.updatedesc : ''
				// alert(this.config.data.updatedesc)
				return vl
			},
			prdes() {
				return (this.config.data) ? this.config.data.appDesc : ''
			},
			uData() {
				return {
					token: 1234
				}
			},
			imgUploadUrl() {
				// return this.$imgUploadUrl
				return this.$urls.picUrls
			},
			fileUploadUrl() {
				// var vl = this.$urls.apkUrl + '?distributorId=' + this.form.distributorId + '&language=' + localStorage.system_lang
				var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do" + '?distributorId=' + this.form.distributorId + '&language=' + localStorage.system_lang
				return vl
			},
			reason() {
				if (!this.config.data) {
					return ''
				}
				var rs = this.config.data.refuseReason
				return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput')
			},
			isShowReason() {
				if (this.config) {
					if (this.config.data) {
						if (this.config.data.appStatus === '3') {
							return 1
						} else {
							return 0
						}
					} else {
						return 0
					}
				} else {
					return 0
				}
			}
		},
		methods: {
			fileFmProcess(file) {
				if (file) {
					var size = file.size / 1024
					if (size == 0) {
						this.$message.error(this.$t('mao_global.tip.notBlank'))
						return false
					}

					var ar = file.name.split('.')
					var type = ar[ar.length - 1]
					type = type.toLowerCase()
					if (type === 'jpg' || type === 'png' || type === 'gif') {
						return true
					} else {
						this.$message.error(this.$t('app_onlypicfm'))
						return false
					}
				} else {
					this.$message.error(this.$t('app_onlypicfm'))
					return false
				}
			},
			editApp(row) {

			},
			selectChange(vl) {
				this.getDevices()
			},
			getChannels() {
				var _this = this
				this.$getChannelList(10000, 1, '', '', '', (res) => {
					if (res.status === 200) {
						_this.channels = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			getStatus(value) {
				switch (value) {
					case '0':
						return this.$t('app_prePushVerify')
					case '1':
						return this.$t('app_preVerify')
					case '2':
						return this.$t('app_verifyPass')
					case '3':
						return this.$t('app_verifyNotPass')
				}
			},
			pageSelect(index) {
				this.index = index
				this.getDevices()
			},
			pageSized(val) {
				this.$gRow = val
				this.getDevices()
			},
			hBlur(name) {
				this.form.caps = this.makeCapture()
				this.$refs[name].validate((valid) => {
					if (valid) {} else {
						return false
					}
				})
			},
			showBigPic() {
				this.showPic = {
					value: 1,
					data: this.imgFullUrl(this.config.data.appBigIcon)
				}
			},
			showScreenShot(path) {
				this.showPic = {
					value: 1,
					data: this.imgFullUrl(path)
				}
			},
			pushInstall() {
				this.dialogVisible = true
				//console.log(this.config.app)
				//this.$router.push({path: '/verify/push'})
			},
			makeAppPath(url) {
				var path = url
				if (!path) {
					if (this.config.data) {
						path = this.config.data.appUrl
						if (!path) {
							return ''
						}
					} else {
						return ''
					}
				}
				var arr = path.split('/')
				return arr[arr.length - 1]
			},
			deleteAppHis(row) {
				// console.log(row)
				if (row.applicationid) {
					this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
						confirmButtonText: this.$t('app_sure'),
						cancelButtonText: this.$t('app_cancel'),
						type: 'warning'
					}).then(() => {
						this.loading = 1
						if (this.$appUrlTag === 0) {
							this.$deleteApp(row.applicationid, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.getAppHistory()
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								// error
								this.loading = 0
							})
						} else {
							this.$deleteApp1(row.applicationid, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.getAppHistory()
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								// error
								this.loading = 0
							})
						}

					}).catch(() => {})
				}
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date === undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD hh:mm:ss')
			},
			deleteCapture0() {
				this.cp0 = ''
				this.cp0Value = ''
			},
			deleteCapture1() {
				this.cp1 = ''
				this.cp1Value = ''
			},
			deleteCapture2() {
				this.cp2 = ''
				this.cp2Value = ''
			},
			deleteCapture3() {
				this.cp3 = ''
				this.cp3Value = ''
			},
			deleteCapture4() {
				this.cp4 = ''
				this.cp4Value = ''
			},
			imgFullUrl(path) {
				if (path) {
					// return this.$host + path
					return this.$urls.prefix + path
				} else {
					return ''
				}
			},
			close() {
				this.$router.go(-1)
			},
			isShowCommon(isShow) {
				// 新建为默认入框，编辑不显示输入框，其他
				if (isShow && (this.config.type === 2 || this.config.type === 3)) {
					return 1
				} else if (!isShow && (this.config.type !== 2 && this.config.type !== 3)) {
					return 1
				} else {
					return 0
				}
			},
			tipBf(file) {
				if (this.fileFmProcess(file)) {
					this.loading1 = 1
					return true
				} else {
					return false
				}
			},
			handleSmAvatarSuccess(res, file) {
				// console.log(res)
				this.loadingSm = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.form.smImageUrlValue = res.data
					this.smImageUrl = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleBgAvatarSuccess(res, file) {
				this.loadingBig = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.form.bgImageUrlValue = res.data
					this.bgImageUrl = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp0(res, file) {
				this.loading1 = 0
				// console.log(res)
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp0Value = res.data
					this.cp0 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp1(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp1Value = res.data
					this.cp1 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp2(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp2Value = res.data
					this.cp2 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp3(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp3Value = res.data
					this.cp3 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp4(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp4Value = res.data
					this.cp4 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			beforeSmAvatarUpload(file) {
				var size = file.size / 1024
				if (size > 100) {
					this.$message.error(this.$t('app_fileOver') + '100k')
					return false
				}
				if (this.fileFmProcess(file)) {
					this.loadingSm = 1
					return true
				} else {
					return false
				}
			},
			beforeBgAvatarUpload(file) {
				var size = file.size / 1024
				if (size > 200) {
					this.$message.error(this.$t('app_fileOver') + '200k')
					return false
				}

				if (this.fileFmProcess(file)) {
					this.loadingBig = 1
					return true
				} else {
					return false
				}
			},
			handleRemove(file, fileList) {
				// console.log(file, fileList)
			},
			makeCapture() {
				var str = ''
				if (this.cp0Value) {
					str += this.cp0Value + ','
				}
				if (this.cp1Value) {
					str += this.cp1Value + ','
				}
				if (this.cp2Value) {
					str += this.cp2Value + ','
				}
				if (this.cp3Value) {
					str += this.cp3Value + ','
				}
				if (this.cp4Value) {
					str += this.cp4Value + ','
				}
				return str.substring(0, str.length - 1)
				/* arr.forEach((value, index, array) => {
				  path += value.response.data + ','
				})
				return path.substring(0, path.length - 1) */
			},
			uploadApp(formName) {

				if (window[this.$route.path]) {
					this.$message.error(this.$t('app_appLoding'))
					return
				}
				// if (this.form.appTypeValue.length <= 0) {
				//   this.$message.error(this.$t('lin_global.qxzlx'))
				//   return
				// }
				// if (!this.form.distributorId) {
				//   this.$message.error(this.$t('app_selectChannel'))
				//   return
				// }
				this.form.caps = this.makeCapture()
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loading = 1
						if (this.config.type === 1) {

							var atvl = this.form.appTypeValue

							this.$editApp1(this.form.md5, this.form.distributorId, this.fileSize, this.form
								.packageName, this.form.verTag, this.config.data.applicationid, this.form
								.appUrl, this.form.bgImageUrlValue, this.form.smImageUrlValue, atvl, this.form
								.appDesc, 0, this.form.appName, this.form.caps, this.form.version, (res) => {
									console.log(res)
									this.loading = 0
									if (res.status === 200) {
										this.$router.go(-1)
									} else {
										this.$message(res.message)
									}
								}, () => {
									this.loading = 0
									this.$message(this.$t('app_rqsError'))
								})

						} else {
							var atvl = this.form.appTypeValue
							// this.form.appTypeValue = this.form.appTypeValue[0]
							// if (this.$appUrlTag === 0) {
							//   this.$uploadApp(this.form.md5, this.form.distributorId, this.form.verTag, this.form.packageName, this.fileSize, this.form.appUrl, this.form.bgImageUrlValue, this.form.smImageUrlValue, this.form.appTypeValue, this.form.appDesc, 0, this.form.appName, this.form.caps, this.form.version, (res) => {
							//     console.log(res)
							//     this.loading = 0
							//     if (res.status === 200) {
							//       this.$router.go(-1)
							//     } else {
							//       this.$message(res.message)
							//     }
							//   }, () => {
							//     this.loading = 0
							//     this.$message(this.$t('app_rqsError'))
							//   })
							// } else {
							// }
							this.$uploadApp1(this.form.md5, this.form.distributorId, this.form.verTag, this.form
								.packageName, this.fileSize, this.form.appUrl, this.form.bgImageUrlValue, this
								.form.smImageUrlValue, atvl, this.form.appDesc, 0, this.form.appName, this.form
								.caps, this.form.version, (res) => {
									this.loading = 0
									if (res.status === 200) {
										// this.$router.go(-1)
										this.$setWObj("appDisplay", {
											appid: res.data.appId,
											mech: res.data.distributorId
										});
										this.$router.push({
											path: '/applist/display'
										});
									} else {
										this.$message(res.message)
									}
								}, () => {
									this.loading = 0
									this.$message(this.$t('app_rqsError'))
								})

						}
					} else {
						return false
					}
				})
			},
			fileUploadSuccess(res, file) {
				window[this.$route.path] = ''
				// console.log('file', res)
				this.ulinfo.tip = res.message
				if (res.status === 200) {
					this.form.appUrl = res.fileUrl
					this.form.verTag = res.versionCode
					this.form.version = res.appVersion
					this.form.packageName = res.packageName
					this.form.md5 = res.md5
					this.fileSize = res.appSize
					this.fileList = [{
						name: file.name
					}]
					this.hBlur('form')
					this.ulinfo.index = 1
					this.tipColor = {
						color: '#13CE66'
					}
				} else {
					this.ulinfo.index = 2
					this.form.version = ''
					this.form.verTag = ''
					this.form.packageName = ''
					if (this.config.type !== 1) {
						this.fileList = []
					} else {
						this.fileList = [{
							name: this.makeAppPath(this.config.data.appUrl)
						}]
					}
					this.$message.error(res.message)
					this.tipColor = {
						color: '#FF4949'
					}
				}
			},
			fileBeforeUpload(file) {
				if (file) {
					var ar = file.name.split('.')
					var type = ar[ar.length - 1]
					if (type === 'apk' || type === 'hap') {
						var limit = 500000 // k单位
						if (file.size / 1000 > limit) {
							this.$message.error(this.$t('app_fileOver') + '500M')
							return false
						}
						window[this.$route.path] = 1
						return true
					} else {
						this.$message.error(this.$t('app_onlyApk_2'))
						return false
					}
				} else {
					this.$message.error(this.$t('app_onlyApk_2'))
					return false
				}
			},
			setCapturesIn(strs) {
				if (strs) {
					var arr = strs.split(',')
					// console.log('ddd', arr)
					arr.forEach((value, index, array) => {
						switch (index) {
							case 0:
								this.cp0 = this.imgFullUrl(value)
								this.cp0Value = value
								break
							case 1:
								this.cp1 = this.imgFullUrl(value)
								this.cp1Value = value
								break
							case 2:
								this.cp2 = this.imgFullUrl(value)
								this.cp2Value = value
								break
							case 3:
								this.cp3 = this.imgFullUrl(value)
								this.cp3Value = value
								break
							case 4:
								this.cp4 = this.imgFullUrl(value)
								this.cp4Value = value
								break
						}
					})
				}
			},
			setCapturesArr(strs) {
				if (strs) {
					var arr = strs.split(',')
					this.captures = arr
				}
			},
			fillEdit() {
				var data = this.config.data
				this.form.version = data.appVersion
				this.form.appDesc = data.appDesc
				this.form.appName = data.appName
				this.form.verTag = data.versioncode
				this.form.packageName = data.packagename
				this.form.appTypeValue = data.appCategoryId.split(',').length > 1 ? data.appCategoryId.split(',')[1] : ''
				this.smImageUrl = this.imgFullUrl(data.appSmallIcon)
				this.form.smImageUrlValue = data.appSmallIcon
				this.bgImageUrl = this.imgFullUrl(data.appBigIcon)
				this.form.bgImageUrlValue = data.appBigIcon
				this.form.appUrl = data.appUrl
				this.form.distributorId = data.distributorId
				var _this = this
				this.getTypeList(data.distributorId)
				this.mechanismData = {
					value: data.distributorName,
					callback(value) {
						if (!value) _this.form.distributorId = ''
						_this.getTypeList(value)
						_this.form.appTypeValue = ''
						_this.form.appUrl = ''
						_this.form.distributorId = value == 1 ? '' : value
					}
				}
				this.fileList = [{
					name: this.makeAppPath(data.appUrl)
				}]
				this.setCapturesIn(data.appScreenShot)
				this.fileSize = data.appSize
				// console.log('fillll', data)
			},
			getTypeList(mcid) {
				var mc = mcid ? mcid : ''
				// this.$gpAppType(mc, (res) => {
				//   if (res.data.length > 0) {
				//     // this.appTypes = res.data[0].children
				//   if (res.value) {
				//      res.data[0].children
				//   } else
				//     this.appTypes = res.data
				//   }
				// }, '')

				this.$acMcFindApptype(mc, (res) => {
					if (res.status === 200) {
						this.appTypes = res.data
					} else {
						this.$message(res.message)
					}
				}, '')
			},
			cancel() {
				// cancel
				this.$router.go(-1)
			},
			verifyPre() {
				this.$confirm(this.$t('app_isSubmitToCheck'), this.$t('app_tip'), {
					confirmButtonText: this.$t('app_sure'),
					cancelButtonText: this.$t('app_cancel'),
					type: 'warning'
				}).then(() => {
					this.verify()

				}).catch(() => {

				})
			},
			verify() {
				this.loading = 1
				var id = this.config.data.applicationid
				var passValue = (this.radio === '1') ? '2' : '3'
				var desc = this.checkDesc
				if (this.$appUrlTag === 0) {
					this.$verifyApp(localStorage.user, id, passValue, desc, (res) => {
						this.loading = 0
						if (res.status === 200) {
							this.$router.go(-1)
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = 0
						this.$message.error(this.$t('app_rqsError'))
					})
				} else {
					this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, (res) => {
						this.loading = 0
						if (res.status === 200) {
							this.$router.go(-1)
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = 0
						this.$message.error(this.$t('app_rqsError'))
					})
				}

			},
			getAppHistory() {
				if (!this.config.data.appName) {
					return
				}
				console.log('pkg', this.config.data)
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
						console.log('reslist', res)
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})
				} else {
					this.$getAppHistory1(this.mechanismId, this.config.data.packagename, (res) => {
						console.log('reslist', res)
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})
				}

			},
			uploadNew() {
				// this.config = {type: 4, data: this.config}

				this.$router.push({
					name: this.$t('menu.appManageSub.uploadNew')
				})
			},
			setInstallType(type) {
				return this.$installType[type]
			},
			init() {
				this.config = this.$getWObj().editAppConfig
				console.log('config', this.config)
				// 0新建 1编辑 2展示 3审核
				switch (this.config.type) {
					case 0:
						// this.getTypeList()
						break
					case 1:
						// this.getTypeList()
						this.fillEdit()
						break
					case 2:
						// this.getTypeList()
						// console.log(this.config.data.appScreenShot)
						this.setCapturesArr(this.config.data.appScreenShot)
						this.getAppHistory()
						break
					case 3:
						this.getChannels()
						this.getDevices()
						this.setCapturesArr(this.config.data.appScreenShot)
						break
				}
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : ''
				var channel = this.channelId ? this.channelId : ''
				var status = this.status ? this.status : ''
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, (
						res) => {
							console.log('dv', res)
							this.loading = 0
							if (res.data) {
								this.tableData = res.data
								this.total = res.total
							}
						}, () => {
							// error
							this.loading = 0
						})
				} else {
					this.$getDevices1(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, (
						res) => {
						console.log('dv', res)
						this.loading = 0
						if (res.data) {
							this.tableData = res.data
							this.total = res.total
						}
					}, () => {
						// error
						this.loading = 0
					})
				}

			},
			bindOperate(row) {
				this.bind(row.terminalId, row.terminalNo, row.manufId)
			},
			bind(tId, tNo, mId) {
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$bindApp('0', tId, this.config.data.applicationid, (res) => {
						if (res.status === 200) {
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
						this.loading = 0
					}, () => {
						// error
						this.loading = 0
					})
				} else {
					// console.log(localStorage.mechanismId, tNo)
					this.$verifyAppPush(mId, tNo, this.config.data.applicationid, (res) => {
						if (res.status === 200) {
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
						this.loading = 0
					}, () => {
						// error
						this.loading = 0
					})
				}

			},
			srchDevice() {
				this.getDevices()
			}
		},
		mounted() {
			// stModel

			this.tqobj = {
				keys: ['terminalTypes'],
				callback: data => {
					this.stModel = data[0]
					this.status = '1'
					this.init()
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// appedit.vue?579e2327